var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

const SvgSend = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "send-icon")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "send-icon",
    transform: "translate(-3.000000, -4.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.83426485,19.1096346 L19.419927,10.8172757 L11.7513973,20.3853821 L11.7513973,23.3621262 C11.7513973,23.7873754 11.8934071,24 12.1774267,24 C12.6034561,24 13.0294856,23.3621262 13.2425003,23.1495017 C13.3845101,23.0077519 13.9525493,22.3698782 14.946618,21.2358804 L18.7808828,22.7242525 C19.2069123,22.8660022 19.4909319,22.7242525 19.6329417,22.2990033 C19.8459564,21.6611296 21.9115904,9.33510121 21.9761036,8.90365449 C22.0406167,8.47220776 21.9761036,8.26578073 21.7630888,8.05315615 C21.621079,7.91140642 21.1950496,8.05315615 20.4850006,8.47840532 L6.42602943,16.5581395 C6.14200981,16.6998893 6,16.9125138 6,17.1960133 C6,17.4795127 6.25977404,17.6987278 6.77932212,17.8536585 L9.83426485,19.1096346 Z"
  })))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSend, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/send.839b04e6.svg";
export { ForwardRef as ReactComponent };